import { useState, useEffect } from "react";
import { truncateText } from "../../utils/Uility";
import { removeItem, updateCartAmount } from "../../features/cart/cartSlice";
import { useDispatch } from "react-redux";
import { PencilSquareIcon } from "@heroicons/react/24/solid";
import { shoppingSvg } from "../../assets/images";

function CardProduct({ product, order }) {
  const dispatch = useDispatch();
  const [editIndex, setEditIndex] = useState(null);
  const [updatedProducts, setUpdatedProducts] = useState(product);

  // Update the local state when the product prop changes
  useEffect(() => {
    setUpdatedProducts(product);
  }, [product]);

  const handleChange = (e, index) => {
    const { name, value } = e.target;
    const updatedProduct = [...updatedProducts];
    updatedProduct[index] = { ...updatedProduct[index], [name]: value };
    setUpdatedProducts(updatedProduct);
  };

  const handleEdit = (index) => {
    dispatch(updateCartAmount(updatedProducts[index]));
    setEditIndex(null);
  };

  return (
    <div className="p-4">
      {updatedProducts.map((item, index) => (
        <div
          key={item.id} // Use a unique id for better performance and React optimization
          className="flex items-center border-b w-full py-3 gap-4 transition-all"
        >
          <img
            src={
              item.image
                ? `${process.env.REACT_APP_BACK_URL}${item.image}`
                : shoppingSvg
            }
            alt={item.title}
            className="h-12 w-12 object-cover object-center"
          />
          <div className="w-full flex flex-col gap-1">
            <p className="flex items-center justify-between text-sm font-semibold text-gray-900">
              <span className="truncate">
                {truncateText(item.name, order ? 100 : 20)}
              </span>
              <span className="text-[16px]">
                {item.price} {item.unit}
              </span>
            </p>
            <p className="text-sm text-gray-700">
              {truncateText(item.description, order ? 150 : 20)}
            </p>
            <p className="flex justify-between items-center gap-1 text-lg font-medium text-blue-gray-500">
              <span className="flex items-center">
                Qty:{" "}
                {editIndex === index ? (
                  <input
                    type="number"
                    value={item.quantity}
                    name="quantity"
                    onChange={(e) => handleChange(e, index)}
                    className="w-12 h-8 border border-gray-400 rounded-md text-center"
                  />
                ) : (
                  item.quantity || 1
                )}
              </span>
              <span className="flex items-center gap-2">
                {editIndex === index ? (
                  <button
                    onClick={() => handleEdit(index)}
                    className="btn btn-xs btn-ghost hover:bg-success hover:text-white"
                  >
                    Enregistrer
                  </button>
                ) : (
                  <PencilSquareIcon
                    className="h-4 w-4 cursor-pointer hover:text-blue-600"
                    onClick={() => setEditIndex(index)}
                  />
                )}
                <button
                  onClick={() => dispatch(removeItem(item.id))}
                  className="btn btn-xs btn-ghost hover:bg-error hover:text-white"
                >
                  Supprimer
                </button>
              </span>
            </p>
          </div>
        </div>
      ))}
    </div>
  );
}

export default CardProduct;